import { comboExtra, comboValid } from "./QrComboChoices";
export const money = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
export const BRAND = "Shri Umesh Son’s Malai Chaap";
export const newRequestId = () => `crq-${globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`}`;
export const lineKey = (item, variant, addons, note, picks = []) => JSON.stringify([
  item.id, variant || "", addons.map((a) => a.name.toLowerCase()).sort(), (note || "").trim(), !!item.is_combo, [...picks].sort(),
]);
export const unitPrice = (item, variant) => variant
  ? Number(item.variants?.find((v) => v.name === variant)?.price ?? item.base_price)
  : Number(item.base_price);
export const lineTotal = (line) => Number(((line.unit + line.addons.reduce((s, a) => s + Number(a.price || 0), 0)) * line.quantity).toFixed(2));
export const cartTotal = (cart) => Number(cart.reduce((s, line) => s + lineTotal(line), 0).toFixed(2));
export const blankDraft = () => ({ cart: [], name: "", phone: "", instructions: "", requestId: newRequestId(), placedId: null, lastRequestId: null, submission: null });
const storageKey = (token) => `table-qr-draft-v2:${token}`;
export function readDraft(token) {
  try {
    const d = JSON.parse(sessionStorage.getItem(storageKey(token)) || "null");
    if (d && Date.now() - d.savedAt < 24 * 60 * 60 * 1000 && Array.isArray(d.cart) && d.requestId) return d;
  } catch { /* Browsing remains available when storage is restricted. */ }
  return blankDraft();
}
export function persistDraft(token, draft) {
  try { sessionStorage.setItem(storageKey(token), JSON.stringify({ ...draft, savedAt: Date.now() })); return true; }
  catch { return false; }
}
export function reconcileCart(cart, menu) {
  return cart.map((line) => {
    const item = (line.item?.is_combo ? menu.combos || [] : menu.items).find((i) => i.id === line.item?.id);
    const valid = !!item?.is_available && (!line.variant || item.variants?.some((v) => v.name === line.variant))
      && (line.addons || []).every((a) => item.addons?.some((x) => x.name === a.name)) && comboValid(item || {}, line.combo_choices || []);
    const addons = (line.addons || []).map((a) => item?.addons?.find((x) => x.name === a.name) || a);
    return { ...line, item: item || { ...line.item, is_available: false }, addons, valid, unit: item ? unitPrice(item, line.variant) + comboExtra(item, line.combo_choices) : line.unit };
  });
}
export function saveCartLine(cart, item, variant, addons, note, quantity, editingKey, picks = []) {
  const key = lineKey(item, variant, addons, note, picks);
  const others = cart.filter((l) => l.key !== editingKey);
  const existing = others.find((l) => l.key === key);
  if (existing) return others.map((l) => l.key === key ? { ...l, quantity: Math.min(99, l.quantity + quantity) } : l);
  return [...others, { key, item, variant, addons, note: note.trim(), quantity, combo_choices: picks, unit: unitPrice(item, variant) + comboExtra(item, picks), valid: true }];
}